import fecha from 'fecha';
import filesize from 'filesize';
import getMess from './translations';
import { systemFolderType } from '../../../shared/constants/systemFolderType';

const TABLET_WIDTH = 1024;
const MOBILE_WIDTH = 640;

function formatSize(viewLayoutOptions, { cellData, columnData, columnIndex, dataKey, isScrolling, rowData, rowIndex }) {
  if (dataKey === 'size' && rowData.type === 'dir') {
    if (
      rowData.isSystemFolder &&
      (+rowData.systemFolderType === systemFolderType.INSURED_ONEDRIVE_FOLDER ||
        +rowData.systemFolderType === systemFolderType.INSURED_GOOGLEDRIVE_FOLDER)
    ) {
      return '';
    } else if (rowData.isOneDrive) {
      return `${rowData.size || 0} Files/Folders`;
    } else {
      return `${rowData.filesChildrenCount || 0} Files, ${rowData.foldersChildrenCount || 0} Folders`;
    }
  }

  if (typeof cellData !== 'undefined' && viewLayoutOptions.humanReadableSize) {
    return filesize(cellData);
  }

  return cellData || '—';
}

function formatDate(viewLayoutOptions, { cellData, columnData, columnIndex, dataKey, isScrolling, rowData, rowIndex }) {
  if (
    rowData.isSystemFolder &&
    (+rowData.systemFolderType === systemFolderType.INSURED_ONEDRIVE_FOLDER ||
      +rowData.systemFolderType === systemFolderType.INSURED_GOOGLEDRIVE_FOLDER)
  ) {
    return '';
  }
  if (cellData) {
    const { dateTimePattern } = viewLayoutOptions;
    return fecha.format(new Date(cellData), dateTimePattern);
  }

  return '';
}

const listViewLayout = (viewLayoutOptions) => {
  const getMessage = getMess.bind(null, viewLayoutOptions.locale);
  return [
    {
      elementType: 'Column',
      elementProps: {
        key: 'name',
        dataKey: 'name',
        width: viewLayoutOptions.columnWidths.name,
        label: getMessage('title'),
        flexGrow: 0,
        flexShrink: 0,
        onColumnResize: viewLayoutOptions.onColumnResize,
        onSort: viewLayoutOptions.onSort,
        cellRenderer: {
          elementType: 'NameCell',
          callArguments: [viewLayoutOptions],
        },
        headerRenderer: {
          elementType: 'HeaderCell',
          callArguments: [viewLayoutOptions],
        },
        disableSort: false,
      },
    },
    {
      elementType: 'Column',
      elementProps: {
        key: 'description',
        width: viewLayoutOptions.columnWidths.description,
        dataKey: 'description',
        label: getMessage('description'),
        flexGrow: 0,
        flexShrink: 0,
        onColumnResize: viewLayoutOptions.onColumnResize,
        onSort: viewLayoutOptions.onSort,
        cellRenderer: {
          elementType: 'Cell',
          callArguments: [{ ...viewLayoutOptions }],
        },
        headerRenderer: {
          elementType: 'HeaderCell',
          callArguments: [viewLayoutOptions],
        },
        disableSort: true,
      },
    },
    {
      elementType: 'Column',
      elementProps: {
        key: 'size',
        width: viewLayoutOptions.columnWidths.size,
        dataKey: 'size',
        label: getMessage('fileSize'),
        flexGrow: 0,
        flexShrink: 0,
        onColumnResize: viewLayoutOptions.onColumnResize,
        onSort: viewLayoutOptions.onSort,
        cellRenderer: {
          elementType: 'Cell',
          callArguments: [{ ...viewLayoutOptions, getData: formatSize }],
        },
        headerRenderer: {
          elementType: 'HeaderCell',
          callArguments: [viewLayoutOptions],
        },
        disableSort: true,
      },
    },
    {
      elementType: 'Column',
      elementProps: {
        key: 'uploader',
        width: viewLayoutOptions.columnWidths.uploader,
        dataKey: 'uploader',
        label: getMessage('uploader'),
        flexGrow: 0,
        flexShrink: 0,
        onColumnResize: viewLayoutOptions.onColumnResize,
        onSort: viewLayoutOptions.onSort,
        cellRenderer: {
          elementType: 'Cell',
          callArguments: [{ ...viewLayoutOptions }],
        },
        headerRenderer: {
          elementType: 'HeaderCell',
          callArguments: [viewLayoutOptions],
        },
        disableSort: true,
      },
    },
    (viewLayoutOptions.width > MOBILE_WIDTH || viewLayoutOptions.showAllInfo) && {
      elementType: 'Column',
      elementProps: {
        key: 'createDate',
        width: viewLayoutOptions.columnWidths.createDate,
        dataKey: 'createDate',
        label: getMessage('createDate'),
        flexGrow: 0,
        flexShrink: 0,
        onColumnResize: viewLayoutOptions.onColumnResize,
        onSort: viewLayoutOptions.onSort,
        cellRenderer: {
          elementType: 'Cell',
          callArguments: [{ ...viewLayoutOptions, getData: formatDate }],
        },
        headerRenderer: {
          elementType: 'HeaderCell',
          callArguments: [viewLayoutOptions],
        },
        disableSort: false,
      },
    },
    (viewLayoutOptions.width > MOBILE_WIDTH || viewLayoutOptions.showAllInfo) && {
      elementType: 'Column',
      elementProps: {
        key: 'changeDate',
        width: viewLayoutOptions.columnWidths.changeDate,
        dataKey: 'changeDate',
        label: getMessage('changeDate'),
        flexGrow: 0,
        flexShrink: 0,
        onColumnResize: viewLayoutOptions.onColumnResize,
        onSort: viewLayoutOptions.onSort,
        cellRenderer: {
          elementType: 'Cell',
          callArguments: [{ ...viewLayoutOptions, getData: formatDate }],
        },
        headerRenderer: {
          elementType: 'HeaderCell',
          callArguments: [viewLayoutOptions],
        },
        disableSort: false,
      },
    },
  ];
};

export default listViewLayout;
